import React from "react";
import useReveal from "@/hooks/useReveal";

const Terms: React.FC = () => {
  useReveal();
  return (
    <main className="iav-page" data-testid="terms-page">
      <section className="iav-page-hero">
        <div className="iav-page-hero-inner">
          <span className="iav-tag-line" data-reveal>Legal</span>
          <h1 data-reveal>TERMS &amp;<br /><span className="iav-accent">CONDITIONS</span></h1>
          <p className="lead" data-reveal>Last updated: 1 January 2026</p>
        </div>
      </section>

      <article className="iav-article" data-reveal>
        <p>These Terms &amp; Conditions govern your use of the Ideation Audio Visual website at www.ideationav.com and any services offered through it. By using this website you agree to be bound by these terms.</p>

        <h2>Use Of The Website</h2>
        <p>The content on this site is provided for general information about Ideation Audio Visual and our services. You agree not to use the site for any unlawful purpose, to introduce malicious code, or to interfere with the operation of the site.</p>

        <h2>Intellectual Property</h2>
        <p>All content, photography, graphics, branding and code on this website are the property of Ideation Audio Visual or its licensors and are protected by applicable copyright and trademark law. You may not reproduce, distribute or modify any portion of the site without prior written consent.</p>

        <h2>Submissions</h2>
        <p>Any information, file or document you submit through our forms must be accurate and lawful. You retain ownership of materials you upload but grant Ideation a limited licence to use those materials for the purpose of responding to your enquiry.</p>

        <h2>Quotations &amp; Proposals</h2>
        <p>Quotes and proposals provided through this website or via email are estimates only and are subject to a signed agreement detailing scope, pricing and delivery timelines. No contract is formed until both parties have signed a definitive agreement.</p>

        <h2>Limitation Of Liability</h2>
        <p>The website is provided on an “as is” basis. To the maximum extent permitted by applicable law, Ideation disclaims all warranties and shall not be liable for any indirect, incidental or consequential damages arising from use of the website.</p>

        <h2>Governing Law</h2>
        <p>These terms shall be governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes shall be subject to the exclusive jurisdiction of the courts of Dubai, UAE.</p>

        <h2>Contact</h2>
        <p>Questions about these terms can be sent to <a href="mailto:info@ideationav.com">info@ideationav.com</a>.</p>
      </article>
    </main>
  );
};
export default Terms;
